// Field names whose values are masked before request/response payloads are
// logged. Mirrors App\Support\SensitiveKeys on the backend (and its other
// frontend counterparts) so nothing in this platform drifts on what counts as
// sensitive.
export const SENSITIVE_KEYS = [
  'password',
  'password_confirmation',
  'current_password',
  'token',
  'access_token',
  'refresh_token',
  'card_number',
  'cvv',
  'secret',
];

export function redact(data: unknown): unknown {
  if (Array.isArray(data)) {
    return data.map(redact);
  }

  if (data === null || typeof data !== 'object') {
    return data;
  }

  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
    result[key] = SENSITIVE_KEYS.includes(key.toLowerCase()) ? '***REDACTED***' : redact(value);
  }
  return result;
}
